import { render, staticRenderFns } from "./CrewList.vue?vue&type=template&id=18332623"
import script from "./CrewList.vue?vue&type=script&lang=js"
export * from "./CrewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports